import { TimeSlot } from '../../types/model';
import {
  isRegistrationClosed,
  isTimeSlotFullyBooked,
  toTimestamp,
} from '../../utils';

export function isRegistrationDisabled(
  selectedTimeslot: TimeSlot,
  isEventFullyBooked: boolean
) {
  return (
    isRegistrationClosed(
      toTimestamp(selectedTimeslot?.utcRegistrationClosedDate as number)
    ) ||
    isEventFullyBooked ||
    isTimeSlotFullyBooked(selectedTimeslot)
  );
}
